const Defrost = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<g fill="#000" clipPath="url(#a)">
			<path d="M1.2 12.8a.8.8 0 0 1 0-1.6H2.47l-1.034-1.034a.8.8 0 0 1 1.13-1.132L4.732 11.2h5.338L6.295 7.426H3.232a.8.8 0 1 1 0-1.6h1.463l-.897-.897a.8.8 0 1 1 1.13-1.132l.898.898V3.232a.8.8 0 1 1 1.6 0v3.063l3.774 3.774V4.73L9.035 2.566a.8.8 0 0 1 1.13-1.132L11.2 2.47v-1.27a.8.8 0 0 1 1.6 0v1.27l1.034-1.035a.8.8 0 0 1 1.132 1.132L12.8 4.73v5.338l3.774-3.774V3.232a.8.8 0 0 1 1.6 0v1.463l.897-.898a.8.8 0 0 1 1.131 1.132l-.897.897h1.463a.8.8 0 1 1 0 1.6h-3.063L13.931 11.2h5.338l2.166-2.166a.8.8 0 0 1 1.13 1.131L21.532 11.2h1.27a.8.8 0 1 1 0 1.6H1.2ZM9.2 20.787a2.806 2.806 0 0 0 3.31 2.768 2.773 2.773 0 0 0 2.287-2.897c-.076-1.747-1.689-2.583-2.566-4.506a.252.252 0 0 0-.462 0c-.899 1.968-2.57 2.799-2.57 4.635ZM16.4 19.187a2.805 2.805 0 0 0 3.31 2.767 2.775 2.775 0 0 0 2.287-2.896c-.076-1.747-1.689-2.583-2.565-4.506a.252.252 0 0 0-.463 0C18.07 16.52 16.4 17.35 16.4 19.187ZM2 19.187a2.806 2.806 0 0 0 3.31 2.767 2.775 2.775 0 0 0 2.287-2.896c-.076-1.747-1.689-2.583-2.565-4.506a.252.252 0 0 0-.463 0C3.67 16.52 2 17.35 2 19.187Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M24 0H0v24h24z" />
			</clipPath>
		</defs>
	</svg>
);
export default Defrost;
